// extracted by mini-css-extract-plugin
module.exports = {"arrow-btn-box":"S","arrowBtnBox":"S","arrow-btn-wrap-box":"T","arrowBtnWrapBox":"T","arrow-btn-text":"U","arrowBtnText":"U","arrow-btn-arrow":"V","arrowBtnArrow":"V"};